import { useDispatch, useSelector } from 'react-redux';
import { usePortalSlice } from '../slice';
import { selectChatSessionIDToDelete } from '../slice/selectors';
import { selectCurrentSessionId } from '../../../containers/chat/slice/selectors';
import { useChatSlice } from '../../../containers/chat/slice';

export default function useChatSessionDeletehandler() {
  const dispatch = useDispatch();
  const { actions } = usePortalSlice();
  const { actions: chatActions } = useChatSlice();
  const chatSessionIDToDelete = useSelector(selectChatSessionIDToDelete);
  const currentSessionId = useSelector(selectCurrentSessionId);
  const handleDelete = (chatSessionID: string) => {
    dispatch(actions.setChatSessionIDToDelete(chatSessionID));
  };

  const handleDeleteConfirmation = () => {
    if (chatSessionIDToDelete) {
      if (chatSessionIDToDelete === currentSessionId) {
        dispatch(chatActions.onNewChat());
      }
      dispatch(actions.deleteChatSession(chatSessionIDToDelete));
    }
  };

  const handleDeleteCancel = () => {
    dispatch(actions.setChatSessionIDToDelete(null));
  };

  return { handleDelete, chatSessionIDToDelete, handleDeleteConfirmation, handleDeleteCancel };
}
